
import {
  GET_SUPPORTING_DOCS,
  GET_SUPPORTING_DOCS_SUCCESS,
  GET_SUPPORTING_DOCS_FAIL,
  POST_SUPPORTING_DOCS,
  ADD_NEW_DOC,
  CLOSE_NEW_DOC,
  POST_SUPPORTING_DOCS_FAIL,
  POST_SUPPORTING_DOCS_SUCCESS
} from './actions.js'

const initialState = {
  documentStats: {},
  documents: [],
  loading: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case GET_SUPPORTING_DOCS:
      return {
        ...state,
        loading: true
      }
    case GET_SUPPORTING_DOCS_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: action.documents,
        documentStats: action.documentStats
      }
    case GET_SUPPORTING_DOCS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case ADD_NEW_DOC:
      return {
        ...state,
        documentStats: {
          ...state.documentStats,
          [action.title]: {
            ...state.documentStats[action.title],
            new: true
          }
        }
      }
    case CLOSE_NEW_DOC:
      return {
        ...state,
        documentStats: {
          ...state.documentStats,
          [action.title]: {
            ...state.documentStats[action.title],
            new: false
          }
        }
      }
    case POST_SUPPORTING_DOCS:
      return {
        ...state,
        loading: true
      }
    case POST_SUPPORTING_DOCS_FAIL:
      return {
        ...state,
        error: action.error
      }
    case POST_SUPPORTING_DOCS_SUCCESS:
      return { ...state }
    default:
      return state
  }
}
